import {Component, OnInit, ViewChild} from '@angular/core';
import {Device} from "../model/device.model";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {DeviceService} from "../device/device.service";
import {UtilService} from "../shared/util.service";

@Component({
    selector: 'app-attributelookup',
    templateUrl: './attributelookup.component.html',
    styleUrls: ['./attributelookup.component.scss'],
    standalone: false
})
export class AttributelookupComponent implements OnInit {
  devices: Device[] = [];
  dataSource = new MatTableDataSource(this.devices);

  defaultColumns = ['name', 'target', 'type', 'company', 'site'];
  columnsToDisplay =  [];

  networks = [];
  types = [];
  attributes = [];

  filters: any = {};

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(
      private service: DeviceService,
      private util: UtilService,

  ) { }

  ngOnInit(): void {
    this.fetchFilters();
    this.setDatatable();

  }

  fetchFilters() {
    this.service.getDeviceFilters().subscribe(resp => {
      if (resp.networks) {
        this.networks = resp.networks;
      }
      if (resp.types) {
        this.types = resp.types;
      }
      if (resp.attributes) {
        this.attributes = resp.attributes;
      }
    });
  }

  setDatatable() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = this.util.tableSorting;
  }

  fetchItems() {
    let attributeColumns = [];

    if (this.filters.attribute && this.filters.attribute.length) {
      attributeColumns = this.attributes.filter(i => this.filters.attribute.includes(i.id)).map(i => i.name);
    }

    this.columnsToDisplay = [...this.defaultColumns, ...attributeColumns, 'action'];

    this.service.postFilters(this.filters).subscribe((resp:any) => {
      console.log(resp);
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.devices = resp;
      this.dataSource.data = this.devices;
    });
  }

  resetFilters() {
    this.filters = {};
    this.devices = [];
  }
}
